export default __webpack_public_path__ + "static/media/8640af72ea73812b70e27bc69703a73a1579285015140.b1683297.webp";